<script setup>
import { RouterView } from 'vue-router'
import Sidebar from '@/components/Sidebar.vue'
import { useAuthStore } from '@/stores'
import { onMounted } from 'vue'

const authStore = useAuthStore()

onMounted(async () => {
  if (authStore.userToken && authStore.userPermissions.length === 0) {
    try {
      await authStore.fetchUserPermissions()
    } catch (error) {
      console.error('Failed to fetch permissions in App.vue:', error)
    }
  }
})
</script>

<template>
  <div>
    <Sidebar v-if="authStore.userToken" />
    <div class="w-full py-10 px-4 sm:px-6 md:px-8 lg:ps-72" v-if="authStore.userToken">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>
    <div v-else>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>
  </div>
</template>

<style scoped></style>
